import { useTranslation } from 'react-i18next';
import { Button } from 'reactstrap';

export interface ResetSplitDialogProps {
  isOpen: boolean;
  pickListLabel: string;
  /** Number of missions that will be deleted (for the warning copy). */
  missionsCount: number;
  pending?: boolean;
  error?: string | null;
  onSubmit: () => void;
  onCancel: () => void;
}

export function ResetSplitDialog({
  isOpen, pickListLabel, missionsCount, pending, error, onSubmit, onCancel,
}: ResetSplitDialogProps) {
  const { t } = useTranslation('picklist');
  if (!isOpen) return null;

  return (
    <div role="dialog" aria-modal="true" aria-label={t('reset_split_dialog.aria_label', { label: pickListLabel })}
         style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}
         onClick={onCancel}>
      <div onClick={(e) => e.stopPropagation()}
           style={{ background: 'var(--vp-bg)', padding: 16, borderRadius: 'var(--vp-r-md)',
                    minWidth: 460, maxWidth: 600, boxShadow: 'var(--vp-shadow-lg)' }}>
        <h5 className="fs-15 mb-2">{t('reset_split_dialog.title', { label: pickListLabel })}</h5>
        <div role="alert" className="alert alert-warning py-2 px-3 small mb-3">
          {t('reset_split_dialog.alert_lead')} <strong>{t('reset_split_dialog.alert_count', { count: missionsCount })}</strong> {t('reset_split_dialog.alert_mid')} <strong>{t('reset_split_dialog.alert_state')}</strong> {t('reset_split_dialog.alert_outro')}
        </div>

        {error && <p role="alert" className="text-danger small mb-0">{error}</p>}

        <div className="d-flex gap-2 justify-content-end mt-3">
          <Button type="button" color="light" onClick={onCancel} disabled={pending}>{t('reset_split_dialog.cancel')}</Button>
          <Button type="button" color="danger" disabled={pending}
                  onClick={() => onSubmit()}>
            {pending ? t('reset_split_dialog.submitting') : t('reset_split_dialog.submit')}
          </Button>
        </div>
      </div>
    </div>
  );
}
